import { useState, useCallback, useEffect } from 'react';
import ApplyExistingPaymentTab from './ApplyExistingPaymentTab';
import RecordNewPaymentTab from './RecordNewPaymentTab';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { fetchAvailableManualPaymentMethods, fetchCommercePaymentMethodTypeProperty } from '../../api/paymentsAPI';
import { addDanger
// @ts-expect-error untyped customer-data-ui-utilities
} from 'customer-data-ui-utilities/alerts/Alerts';
import { getInvoiceProperty } from 'invoices-ui-lib/utils/property';
import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TABS = {
  ADD_NEW: 'ADD_NEW',
  ADD_EXISTING: 'ADD_EXISTING'
};
const RecordPaymentPanel = props => {
  const {
    onAdd,
    onCreate,
    onFailure,
    onReject,
    invoice
  } = props;
  const [selectedTab, setSelectedTab] = useState(TABS.ADD_NEW);
  const [closeButtonIsDisabled, setCloseButtonIsDisabled] = useState(false);
  const [paymentMethodOptions, setPaymentMethodOptions] = useState([]);
  const handleSelectedTabChange = useCallback(event => {
    setSelectedTab(event.target.value);
  }, [setSelectedTab]);
  useEffect(() => {
    Promise.all([fetchAvailableManualPaymentMethods(getInvoiceProperty(invoice, 'hs_currency')), fetchCommercePaymentMethodTypeProperty()]).then(([paymentMethods, {
      property
    }]) => {
      setPaymentMethodOptions(paymentMethods.map(paymentMethod => paymentMethod.toLowerCase()).map(paymentMethod => ({
        text: getDisplayedValue(property, paymentMethod),
        value: paymentMethod
      })).sort((a, b) => {
        if (a.value === 'other' && b.value !== 'other') {
          return 1;
        } else if (a.value !== 'other' && b.value === 'other') {
          return -1;
        }
        return a.text.localeCompare(b.text);
      }));
    }).catch(() => {
      addDanger('invoicesHighlightCard.modals.recordPayment.paymentMethod.fetchFailed.message', {}, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "invoicesHighlightCard.modals.recordPayment.paymentMethod.fetchFailed.title"
        })
      });
      onReject();
    });
  }, [invoice, onReject]);
  return /*#__PURE__*/_jsxs(UIModalPanel, {
    "data-test-id": "invoice-record-payment-panel",
    onEsc: () => {},
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: selectedTab === TABS.ADD_NEW ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "invoicesHighlightCard.modals.recordPayment.title"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "invoicesHighlightCard.modals.applyExistingPayment.title"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onReject,
        disabled: closeButtonIsDisabled
      })]
    }), selectedTab === TABS.ADD_NEW ? /*#__PURE__*/_jsx(RecordNewPaymentTab, {
      invoice: invoice,
      onReject: onReject,
      onFailure: onFailure,
      onSuccess: args => {
        setCloseButtonIsDisabled(true);
        onCreate(args);
      },
      selectedTab: selectedTab,
      setSelectedTab: handleSelectedTabChange,
      paymentMethodOptions: paymentMethodOptions
    }) : /*#__PURE__*/_jsx(ApplyExistingPaymentTab, {
      invoice: invoice,
      onReject: onReject,
      onSuccess: args => {
        setCloseButtonIsDisabled(true);
        onAdd(args);
      },
      onFailure: onFailure,
      selectedTab: selectedTab,
      setSelectedTab: handleSelectedTabChange
    })]
  });
};
export default RecordPaymentPanel;